export interface Referral {
  referredId: string;
  referredName: string;
  totalHoursWorked: number;
  hoursWorkedThisWeek: number;
  joinDate: string;
  totalEarnings: number;
}

export interface CreateReferralInvite {
  name: string;
  phoneNumber?: string;
  email: string;
}

export interface ReferralEarningSummary {
  earningsThisWeek: number;
  hoursThisWeek: number;
  totalEarningsAllTime: number;
  totalReferrals: number;
}

export interface ReferralPageDto {
  referrals?: Referral[];

  invitations?: ReferralInvitationListItemDto[];
}

export interface ReferralInvitationListItemDto {
  id: string;
  name: string;
  email: string;
  invitedAt: string;
}
